import * as React from "react";
function SvgIcLogout(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.75 6.031h6.729v-.75H4V18.8h7.479v-.75H4.75V6.031z"
        fill="currentColor"
      />
      <path
        d="M16.136 5l-.65.375 3.634 6.294h-7.886v.75h7.886l-3.634 6.294.65.375 4.067-7.044L16.136 5z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcLogout;
